import React, { useEffect, useState } from "react";
import "./Calculator.css";
import {
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Button,
} from "@mui/material";
import Form from "react-bootstrap/Form";
import {
  inputLableStyle,
  formControlStyle,
  resultLabelStyle,
} from "../../../../../calculatorStyle";

const Calculator = () => {
  const [originalLoanAmount, setOriginalLoanAmount] = useState(20000);
  const [originalLoanTerm, setOriginalLoanTerm] = useState(60);
  const [originalInterestRate, setOriginalInterestRate] = useState(10);

  const [newLoanAmount, setNewLoanAmount] = useState(15000);
  const [newLoanTerm, setNewLoanTerm] = useState(48);
  const [newInterestRate, setNewInterestRate] = useState(6);

  const [originalPayment, setOriginalPayment] = useState(0);
  const [newPayment, setNewPayment] = useState(0);
  const [monthlySavings, setMonthlySavings] = useState(0);

  const [isShowResult, setIsShowResult] = useState(false);

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      // Allow only numbers and a single decimal point
      setter(Number(value));
    }
  };

  const calculateMonthlyPayment = (P, annualRate, n) => {
    const r = annualRate / 12 / 100; // Convert annual rate to a monthly rate
    return (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  };

  useEffect(() => {
    const calculatedOriginalPayment = calculateMonthlyPayment(
      originalLoanAmount,
      originalInterestRate,
      originalLoanTerm
    );
    const calculatedNewPayment = calculateMonthlyPayment(
      newLoanAmount,
      newInterestRate,
      newLoanTerm
    );
    const calculatedSavings = calculatedOriginalPayment - calculatedNewPayment;

    const formatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    });

    // Update separate states for results
    setOriginalPayment(
      formatter.format(
        isNaN(calculatedOriginalPayment) || !isFinite(calculatedOriginalPayment)
          ? 0
          : Math.round(calculatedOriginalPayment)
      )
    );
    setNewPayment(
      formatter.format(
        isNaN(calculatedNewPayment) || !isFinite(calculatedNewPayment)
          ? 0
          : Math.round(calculatedNewPayment)
      )
    );
    setMonthlySavings(
      formatter.format(
        isNaN(calculatedSavings) || !isFinite(calculatedSavings)
          ? 0
          : Math.round(calculatedSavings)
      )
    );
  }, [
    originalLoanAmount,
    originalInterestRate,
    originalLoanTerm,
    newLoanAmount,
    newInterestRate,
    newLoanTerm,
  ]);

  const handleRefinanceCalculate = () => {
    setIsShowResult(true);
  };

  return (
    <>
      <div className="refinance_calculator__container  ">
        <div className="refinance_calculator_content">
          <div className="">
            <div className="refinance_calculator_header">
              <Typography
                sx={{
                  fontSize: {
                    xs: "22px",
                    sm: "24.4312px",
                    md: "30.2752px",
                    lg: "35.1927px",
                  },
                  color: "#1f1f1f",
                  fontWeight: 600,
                  fontFamily: "'Archivo',sans-serif",
                }}
                className="refinance_calculator_title table_font "
              >
                Auto refinance calculator
              </Typography>
            </div>
            <div className="line mt-3"></div>
            <div className="curren__new_loan_fields">
              <div className="current__loan mt-4">
                <Typography
                  sx={{
                    fontSize: 24,
                    lineHeight: "28px",
                    letterSpacing: "normal",
                    fontWeight: 700,
                    color: "#1f1f1f",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  Current loan
                </Typography>
                <div className="d-flex flex-column flex-md-row mt-3">
                  <div className="details_box p-2">
                    <p style={inputLableStyle} className=" mb-1">
                      Original Loan Amount
                    </p>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        startAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">&#8377;</span>
                          </InputAdornment>
                        }
                        value={formatCurrency(originalLoanAmount)} // Display value with commas
                        onChange={(e) =>
                          handleAmountChange(e, setOriginalLoanAmount)
                        }
                      />
                    </FormControl>
                  </div>

                  <div className="details_box p-2">
                    <p style={inputLableStyle} className=" mb-1">
                      Original Loan Term in Months
                    </p>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        value={originalLoanTerm}
                        onChange={(e) =>
                          handleAmountChange(e, setOriginalLoanTerm)
                        }
                      />
                    </FormControl>
                  </div>
                </div>
                <div
                  id="current_loan__range"
                  className="pl_range_style my-3 px-2"
                >
                  <p style={inputLableStyle} className="mb-2">
                    Original Interest Rate
                  </p>
                  <div className="pl_range p-0">
                    <Form.Range
                      min={"0"}
                      max={"25"}
                      step={0.1}
                      value={originalInterestRate}
                      onChange={(e) =>
                        setOriginalInterestRate(parseFloat(e.target.value))
                      }
                      className="custom-range"
                    />
                  </div>
                  <Typography
                    sx={{
                      fontFamily: "'Archivo', sans-serif",
                      fontSize: "24px",
                      lineHeight: "24px",
                      letterSpacing: "normal",
                      textAlign: "start",
                      fontWeight: 700,
                      color: "#005FB9",
                    }}
                  >
                    {originalInterestRate}%
                  </Typography>
                </div>
              </div>
              <div className="new__loan mt-4">
                <Typography
                  sx={{
                    fontSize: 24,
                    lineHeight: "28px",
                    letterSpacing: "normal",
                    fontWeight: 700,
                    color: "#1f1f1f",
                    fontFamily: "'Archivo',sans-serif",
                  }}
                >
                  New loan
                </Typography>
                <div className="d-flex flex-column flex-md-row mt-3">
                  <div className="details_box p-2">
                    <p style={inputLableStyle} className=" mb-1">
                      Refinanced Loan Amount
                    </p>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        startAdornment={
                          <InputAdornment position="start">
                            <span className="archivo">&#8377;</span>
                          </InputAdornment>
                        }
                        value={formatCurrency(newLoanAmount)} // Display value with commas
                        onChange={(e) =>
                          handleAmountChange(e, setNewLoanAmount)
                        }
                      />
                    </FormControl>
                  </div>

                  <div className="details_box p-2">
                    <p style={inputLableStyle} className="mb-1">
                      New Loan Term in Months
                    </p>

                    <FormControl fullWidth sx={formControlStyle}>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        fullWidth
                        size="small"
                        value={newLoanTerm}
                        onChange={(e) => handleAmountChange(e, setNewLoanTerm)}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="pl_range_style my-3 px-2">
                  <p style={inputLableStyle} className="mb-2">
                    New Interest Rate
                  </p>
                  <div className="pl_range p-0">
                    <Form.Range
                      min={"0"}
                      max={"25"}
                      step={0.1}
                      value={newInterestRate}
                      onChange={(e) =>
                        setNewInterestRate(parseFloat(e.target.value))
                      }
                      className="custom-range"
                    />
                  </div>
                  <Typography
                    sx={{
                      fontFamily: "'Archivo', sans-serif",
                      fontSize: "24px",
                      lineHeight: "24px",
                      letterSpacing: "normal",
                      textAlign: "start",
                      fontWeight: 700,
                      color: "#005FB9",
                    }}
                  >
                    {newInterestRate}%
                  </Typography>
                </div>
              </div>
            </div>
            <div className="calculation_result__container">
              <div className="mt-5">
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    fontFamily: "'Archivo',sans-serif",
                    textTransform: "none",
                  }}
                  onClick={handleRefinanceCalculate}
                >
                  Calculate
                </Button>
              </div>
              <div
                className={`claculation_result__data ${
                  !isShowResult ? "d-none" : "d-block"
                }  mt-4`}
              >
                <div className="mt-1">
                  <Typography
                    sx={{
                      fontSize: 14,
                      lineHeight: "26px",
                      fontWeight: 700,
                      color: "#1f1f1f",
                      fontFamily: "'Archivo',sans-serif",
                    }}
                    className=" archivo mb-1"
                  >
                    Refinancing could save you
                  </Typography>
                </div>
                <div className=" d-flex flex-column gap-3 flex-md-row justify-content-between mt-3">
                  <div>
                    <Typography
                      sx={resultLabelStyle}
                      className="loan_details__label archivo mb-1"
                    >
                      Old EMI
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "'Archivo', sans-serif",
                        fontSize: "24px",
                        lineHeight: "24px",
                        letterSpacing: "normal",
                        textAlign: "start",
                        fontWeight: 700,
                        color: "#005FB9",
                      }}
                    >
                      {originalPayment}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={resultLabelStyle}
                      className="loan_details__label archivo mb-1"
                    >
                      New EMI
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "'Archivo', sans-serif",
                        fontSize: "24px",
                        lineHeight: "24px",
                        letterSpacing: "normal",
                        textAlign: "start",
                        fontWeight: 700,
                        color: "#005FB9",
                      }}
                    >
                      {newPayment}
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      sx={resultLabelStyle}
                      className="loan_details__label archivo mb-1"
                    >
                      Monthly savings
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "'Archivo', sans-serif",
                        fontSize: "24px",
                        lineHeight: "24px",
                        letterSpacing: "normal",
                        textAlign: "start",
                        fontWeight: 700,
                        color: "#005FB9",
                      }}
                    >
                      {monthlySavings}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Calculator;
